// Embla carousel initialization for custom hero section
(function () {
  function initEmblaHeroSections() {
    if (typeof EmblaCarousel !== 'function') return false;

    const viewports = document.querySelectorAll(
      '.custom-hero-section__viewport'
    );
    if (!viewports.length) return true;

    // 自動再生ありでプラグイン未読込の場合は後で再試行
    const needsAutoplayPlugin = Array.from(viewports).some((viewport) => {
      const root = viewport.closest('.custom-hero-section');
      if (!root) return false;
      const a = (root.dataset.autoplay || '').toLowerCase();
      return a === 'true' || a === '1' || a === 'yes';
    });
    if (
      needsAutoplayPlugin &&
      typeof EmblaCarouselAutoplay !== 'function'
    ) {
      return false;
    }

    viewports.forEach((viewport) => {
      if (viewport.dataset.emblaInitialized === 'true') return;
      const root = viewport.closest('.custom-hero-section');
      if (!root) return;

      const autoplayAttr = (root.dataset.autoplay || '').toLowerCase();
      const speedAttr = root.dataset.speed;
      const autoPlayEnabled =
        autoplayAttr === 'true' || autoplayAttr === '1' || autoplayAttr === 'yes';
      const speedMs = (Number(speedAttr) || 5) * 1000;

      const options = {
        loop: true,
        align: 'start',
        dragFree: false,
      };

      const plugins = [];
      if (
        autoPlayEnabled &&
        typeof EmblaCarouselAutoplay === 'function'
      ) {
        plugins.push(
          EmblaCarouselAutoplay({
            delay: speedMs,
            playOnInit: true,
            stopOnInteraction: false,
          })
        );
      }

      const embla = EmblaCarousel(viewport, options, plugins);

      if (autoPlayEnabled) {
        embla.plugins().autoplay?.play();
      }

      const stopAutoplay = () => {
        const autoplay = embla?.plugins()?.autoplay;
        if (autoplay) autoplay.stop();
      };

      // Prev / Next buttons
      const prevButton = root.querySelector('[data-embla-prev]');
      const nextButton = root.querySelector('[data-embla-next]');

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          stopAutoplay();
          embla.scrollPrev();
        });
      }
      if (nextButton) {
        nextButton.addEventListener('click', () => {
          stopAutoplay();
          embla.scrollNext();
        });
      }

      // Dots
      const dotNodes = Array.from(root.querySelectorAll('[data-embla-dot]'));

      const selectDot = () => {
        const selectedSnap = embla.selectedScrollSnap();
        dotNodes.forEach((dot, index) => {
          dot.classList.toggle('slider-counter__link--active', index === selectedSnap);
        });
      };

      dotNodes.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          stopAutoplay();
          embla.scrollTo(index);
        });
      });

      embla.on('select', selectDot);
      selectDot();

      viewport.dataset.emblaInitialized = 'true';
    });

    return true;
  }

  function runWhenReady() {
    if (initEmblaHeroSections()) return;

    // CDN の読み込み完了を待つ: load 後に再試行
    const onLoad = () => {
      initEmblaHeroSections();
    };

    if (document.readyState === 'complete') {
      onLoad();
    } else {
      window.addEventListener('load', onLoad);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runWhenReady);
  } else {
    runWhenReady();
  }
})();
